// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__eyWiX","header":"MergedInvoice_header__3A7S1"};